import { z } from 'zod';

export type FieldValue =
  | string
  | number
  | boolean
  | { [x: string]: FieldValue }
  | FieldValue[]
  | object;

export const FieldValueSchema: z.ZodType<FieldValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({}),
    z.array(FieldValueSchema),
    z.record(z.string(), FieldValueSchema)
  ])
);
